import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { ChartModule } from '../chart/chart.module';
import { GroupedBarChartModule } from '../grouped-bar-chart/grouped-bar-chart.module';
import { ToggleModule } from '../toggle/toggle.module';
import { DrilldownToggleChartComponent } from './drilldown-toggle-chart.component';
import { DrilldownToggleChartLegendComponent } from './drilldown-toggle-chart-legend/drilldown-toggle-chart-legend.component';

@NgModule({
  declarations: [DrilldownToggleChartComponent, DrilldownToggleChartLegendComponent],
  exports: [DrilldownToggleChartComponent, DrilldownToggleChartLegendComponent],
  imports: [BrowserModule, ChartModule, ToggleModule, GroupedBarChartModule],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DrilldownChartToggleModule {}
